import React from 'react';

export default function TagIcon() {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_1658_876)'>
        <path
          d='M4.66634 4.66671H4.67301M7.99967 1.33337H1.33301V8.00004L7.52634 14.1934C8.15301 14.82 9.17967 14.82 9.80634 14.1934L14.193 9.80671C14.8197 9.18004 14.8197 8.15337 14.193 7.52671L7.99967 1.33337Z'
          stroke='url(#paint0_linear_1658_876)'
          strokeWidth='1.25'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <linearGradient
          id='paint0_linear_1658_876'
          x1='1.23001'
          y1='-1.4055'
          x2='10.9066'
          y2='12.778'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' />
          <stop offset='1' stopColor='white' stopOpacity='0.65' />
        </linearGradient>
        <clipPath id='clip0_1658_876'>
          <rect width='16' height='16' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
}
